<template>
  <main>
    <ul>
      <li>
        <img src="../assets/indeximg/scxl.png" alt="" />
        快速解答技术疑问
      </li>
      <li>
        <img src="../assets/indeximg/快速解答技术问题1.png" alt="" />
        免费咨询
      </li>
      <li>
        <img src="../assets/indeximg/快速解答技术问题2.png" alt="" />
        1V1大客户服务
      </li>
      <li>
        <img src="../assets/indeximg/快速解答技术问题备份3.png" alt="" />
        7X24小时服务
      </li>
    </ul>
    <div class="bottom">
      <div class="box">
        <p>友情链接</p>
        <ul>
          <li>
            <a
              href="https://beian.miit.gov.cn/#/Integrated/index"
              target="_blank"
            >
              工信部备案</a
            >
          </li>
          <li>
            <a href="http://www.fastener-cn.net/#/home" target="_blank">
              紧固件协会</a
            >
          </li>
          <li>
            <a href=""> 我要采购</a>
          </li>
        </ul>
      </div>
      <div class="box">
        <p>友情链接</p>
        <ul>
          <li>
            <a href="http://www.tenglonggroup.com/" target="_blank">
              腾龙精线集团</a
            >
          </li>
          <li>
            <a href="http://www.tdfastener.com/" target="_blank"> 紧固科技</a>
          </li>
          <li>
            <a href="http://www.51hdai.com/" target="_blank"> 我要货代</a>
          </li>
          <li>
            <a href="http://www.tengzhicn.com/login.html" target="_blank">
              后台管理</a
            >
          </li>
        </ul>
      </div>
      <div class="box">
        <p>公司地址</p>
        <ul>
          <li>浙江：宁波市高新区研发园B区四栋203室</li>
          <li>联系：0574-86161000　13567840222</li>
          <li>山东：山东省滕州市益康大道887号</li>
          <li>联系：15866233000</li>
        </ul>
      </div>
      <div class="box2">
        <span>关注或联系我们</span>
        <p>添加腾智公众号，企业微信。</p>
        <div class="imgDiv">
          <img src="../assets/indeximg/位图.png" alt="" />
          <img src="../assets/er.png" alt="" />
        </div>

        <section>服务热线：400-6696-280</section>
      </div>
    </div>
  </main>
  <div class="b" @click="to">备案号:浙ICP备14030046号-14</div>
</template>

<script setup>
const to = () => {
  location.href = "https://beian.miit.gov.cn/#/Integrated/index";
};
</script>

<style lang="scss" scoped>
.b {
  width: 1920px;
  background: #edf0f5;
  text-align: center;
  height: 110px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #56697e;
  line-height: 38px;
}
main {
  width: 1920px;
  margin: 0 auto;
  background-color: #f6f8fb;
  height: 450px;

  > ul {
    height: 105px;
    margin-left: 160px;
    width: 1660px;
    justify-content: space-between;
    padding: 0 60px;
    border-bottom: 1px solid #dadee2;

    display: flex;

    li {
      display: flex;
      align-items: center;

      img {
        width: 48px;
        height: 48px;
        margin-right: 12px;
      }
    }
  }

  .bottom {
    height: 345px;
    display: flex;
    padding-top: 51px;
    padding-left: 160px;

    .box {
      margin-right: 235px;

      p {
        line-height: 21px;
        margin-bottom: 20px;
        font-size: 15px;
      }

      ul {
        font-size: 15px;

        li {
          line-height: 1;
          margin-top: 14px;
        }

        color: #52677c;
      }
    }

    .box2 {
      color: #52677c;
      font-size: 15px;

      > span {
        margin-left: 15px;
        color: #000;
      }

      > p {
        margin: 20px 0 8px 15px;
      }

      .imgDiv {
        display: flex;
        margin-bottom: 20px;

        img {
          margin-right: 10px;
        }
      }

      section {
        font-size: 18px;

        margin-left: 15px;

        span {
          font-size: 15px;
          color: #000;
        }
      }
    }
  }
}
</style>
